// v1 UI kit: brand bar, phone shell with the three CTV/Đại lý zones, Owner console shell, banners, toasts, formatting.
// The client only displays state and submits intent; every read and write is authorized by the server session.
import { api, h, newKey, type Json } from "../core.ts";
import { bellLink, bellNavItem, pushSignOut } from "./notify.ts";

export { api, h, newKey, type Json };

const P: Record<string, string> = {
  today: "M3 10 12 3l9 7v10a1 1 0 0 1-1 1h-5v-7H9v7H4a1 1 0 0 1-1-1Z",
  search: "M21 21l-5-5M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0",
  people: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75",
  back: "M15 5 8 12l7 7",
  chevron: "m9 5 7 7-7 7",
  bell: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4",
  spark: "m12 3 2.3 6.7L21 12l-6.7 2.3L12 21l-2.3-6.7L3 12l6.7-2.3ZM20 2v4m-2-2h4",
  check: "M5 12.5 10 17 19 7",
  alert: "M12 3 2 20h20zM12 10v4M12 17v.01",
  info: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 11v6M12 7.5v.01",
  lock: "M6 11h12v10H6zM8 11V7a4 4 0 0 1 8 0v4",
  user: "M20 21v-1a5 5 0 0 0-5-5H9a5 5 0 0 0-5 5v1M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8",
  shield: "M12 3 4 6v6c0 5 3.5 8 8 9 4.5-1 8-4 8-9V6z",
  bank: "M3 10h18M5 10v8M9 10v8M15 10v8M19 10v8M3 21h18M12 3 3 8h18z",
  pin: "M12 21s-7-6.5-7-12a7 7 0 0 1 14 0c0 5.5-7 12-7 12M12 11a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  box: "M21 8 12 3 3 8v8l9 5 9-5zM3 8l9 5 9-5M12 13v8",
  coins: "M12 8c4.4 0 8-1.3 8-3s-3.6-3-8-3-8 1.3-8 3 3.6 3 8 3M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6",
  doc: "M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h6",
  clock: "M12 7v5l3 2M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18",
  power: "M12 2v10M18.4 6.6a9 9 0 1 1-12.8 0",
  mail: "M3 5h18v14H3zM3 6l9 7 9-7",
  logout: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9",
  mic: "M12 3a3 3 0 0 0-3 3v6a3 3 0 0 0 6 0V6a3 3 0 0 0-3-3M5 11a7 7 0 0 0 14 0M12 18v3",
  share: "M4 12v7a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-7M16 6l-4-4-4 4M12 2v13",
  image: "M3 5h18v14H3zM3 16l5-5 4 4 3-3 6 6M15 9h.01",
  hand: "M7 11V6a2 2 0 0 1 4 0v5M11 10V4a2 2 0 0 1 4 0v6M15 10V6a2 2 0 0 1 4 0v7a8 8 0 0 1-8 8h-1a7 7 0 0 1-6-3l-2-4a2 2 0 0 1 3-2l2 2",
};

export function ic(name: string, cls = "ic"): SVGSVGElement {
  const ns = "http://www.w3.org/2000/svg";
  const svg = document.createElementNS(ns, "svg");
  svg.setAttribute("viewBox", "0 0 24 24"); svg.setAttribute("class", cls); svg.setAttribute("aria-hidden", "true");
  const p = document.createElementNS(ns, "path"); p.setAttribute("d", P[name] ?? P.info); svg.appendChild(p);
  return svg;
}

export function go(path: string): void {
  history.pushState(null, "", path);
  window.dispatchEvent(new Event("b7b:navigate"));
}

/** Anchor that navigates inside the app (keeps the real href for long-press / new tab). */
export function link(path: string, attrs: Record<string, unknown>, ...children: (Node | string | null | false)[]): HTMLElement {
  return h("a", { href: path, ...attrs, onclick: (e: MouseEvent) => { if (e.ctrlKey || e.metaKey || e.shiftKey) return; e.preventDefault(); go(path); } }, ...children);
}

export function brand(): HTMLElement {
  return h("a", { class: "brand", href: "/", "aria-label": "B7B – 3 Lớp 1 Nghề — về trang chính" },
    h("img", { src: "/brand/icon-128.png", alt: "", width: "36", height: "36" }),
    h("div", {}, h("strong", {}, "B7B – 3 Lớp 1 Nghề"), h("span", { class: "tagline" }, "Lọc SIM 3 Lớp, AI kèm nghề.")));
}

// presentation of the shop's data mode (from /api/v1/me; the server re-checks every write): the real-use shop (0027) shows no DEMO strip
let realShop = false;
export function setDataMode(mode: unknown): void { realShop = mode === "REAL"; }
export const isRealShop = (): boolean => realShop;
export const demoStrip = () => realShop ? null : h("div", { class: "demo-strip", role: "note" }, "DỮ LIỆU DEMO · không có khách thật · không có tiền thật");

export type Zone = "today" | "search" | "customers";

/** CTV / Đại lý phone shell: brand bar + content + the three zones (Hôm nay / Tìm SIM / Khách & Thu nhập). */
export function phone(content: (Node | null | false)[], opts: { zone?: Zone; nav?: boolean; right?: Node } = {}): HTMLElement {
  const nav = opts.nav !== false && opts.zone !== undefined;
  const item = (zone: Zone, path: string, icon: string, label: (Node | string)[]) =>
    link(path, { class: `navitem${opts.zone === zone ? " active" : ""}`, "aria-current": opts.zone === zone ? "page" : null }, ic(icon), h("span", {}, ...label));
  return h("main", { class: `screen${nav ? "" : " no-nav"}` },
    demoStrip(),
    h("header", { class: "brandbar" }, brand(), opts.right ?? bellLink()),
    h("div", { class: "page" }, ...content),
    nav ? h("nav", { class: "bottomnav", "aria-label": "Ba khu chính" },
      item("today", "/hom-nay", "today", ["Hôm nay"]),
      item("search", "/tim-sim", "search", ["Tìm SIM", h("br"), "Lọc 3 Lớp"]),
      item("customers", "/khach", "people", ["Khách &", h("br"), "Thu nhập"])) : null);
}

export function titleRow(title: string, back?: string, extra?: Node): HTMLElement {
  return h("div", { class: "topline" }, back ? link(back, { class: "backbtn", "aria-label": "Quay lại" }, ic("back")) : null, h("h1", { class: "grow" }, title), extra ?? null);
}

export const OWNER_GROUPS: { key: string; path: string; label: string; icon: string }[] = [
  { key: "home", path: "/owner", label: "Tổng quan", icon: "today" },
  { key: "stock", path: "/owner/kho", label: "Kho & giao dịch", icon: "box" },
  { key: "support", path: "/owner/ho-tro", label: "Hỗ trợ giao dịch", icon: "hand" },
  { key: "users", path: "/owner/nguoi-dung", label: "Người dùng & quyền", icon: "people" },
  { key: "money", path: "/owner/tien", label: "Tiền & đối soát", icon: "coins" },
  { key: "content", path: "/owner/noi-dung", label: "Chính sách & nội dung", icon: "doc" },
  { key: "audit", path: "/owner/nhat-ky", label: "Nhật ký & khôi phục", icon: "clock" },
  { key: "stop", path: "/owner/dung", label: "Dừng & AI", icon: "power" },
];

/** Accountant console (Owner-assigned ACCOUNTANT role): bookkeeping only — no users, stock, money power, switches or bank data. */
export const ACCOUNTANT_GROUPS: { key: string; path: string; label: string; icon: string }[] = [
  { key: "orders", path: "/ke-toan", label: "Sổ đơn đã chốt", icon: "doc" },
  { key: "sources", path: "/ke-toan/nguon", label: "Nguồn kích hoạt", icon: "box" },
  { key: "recon", path: "/ke-toan/doi-chieu", label: "Đối chiếu", icon: "check" },
  { key: "dealers", path: "/ke-toan/dai-ly", label: "Bảng đại lý", icon: "people" },
  { key: "dealer-range", path: "/ke-toan/doi-soat-dai-ly", label: "Đối soát đại lý theo ngày", icon: "people" },
  { key: "adjust", path: "/ke-toan/dieu-chinh", label: "Điều chỉnh", icon: "clock" },
  { key: "export", path: "/ke-toan/xuat-file", label: "Xuất file", icon: "share" },
  { key: "practice", path: "/luyen-tap", label: "Luyện tập toàn quy trình", icon: "check" },
];

/** Owner console (or, with ACCOUNTANT_GROUPS, the accountant console): grouped navigation (sidebar on desktop, scrollable strip on phone). */
export function ops(active: string, content: (Node | null | false)[], groups = OWNER_GROUPS, label = "Khu điều hành của Owner"): HTMLElement {
  return h("div", { class: "ops" },
    h("aside", { class: "ops-side" }, brand(),
      h("nav", { class: "ops-nav", "aria-label": label },
        ...groups.map((g) => link(g.path, { class: active === g.key ? "active" : "", "aria-current": active === g.key ? "page" : null }, ic(g.icon, "ic ic-sm"), g.label)),
        bellNavItem(),
        h("a", { href: "#", onclick: (e: Event) => { e.preventDefault(); void logout(); } }, ic("logout", "ic ic-sm"), "Đăng xuất"))),
    h("main", { class: "ops-main" }, demoStrip(), ...content));
}

export async function logout(): Promise<void> {
  await pushSignOut();   // Owner slip 23/10: this device stops receiving this person's phone notifications first
  await api("POST", "/api/auth/logout").catch(() => undefined);
  location.href = "/dang-nhap";
}

export function banner(kind: "info" | "warn" | "error" | "ok", ...children: (Node | string | null)[]): HTMLElement {
  return h("div", { class: `banner ${kind}`, role: kind === "error" ? "alert" : "status" }, ic(kind === "ok" ? "check" : kind === "info" ? "info" : "alert"), h("div", { class: "grow" }, ...children));
}

/** D-03: handoff reasons as the CTV chose them (client/v1/leads.ts); the stored code is never shown to the Owner. */
export const HANDOFF_REASON: Record<string, string> = { AVAILABILITY_ACTIVATION: "Kiểm số / kích hoạt", DEEP_CONSULT: "Tư vấn sâu", PRICE_POLICY: "Giá / chính sách", OTHER: "Khác (nhờ anh Hiếu)" };
export const reasonText = (code: unknown): string => HANDOFF_REASON[String(code)] ?? "Lý do khác";
export const NETWORK_MESSAGE = "Không kết nối được máy chủ. Kiểm tra mạng (wifi/4G) rồi bấm Thử lại.";
/** D-01: fetch() rejects with a TypeError ("Failed to fetch", "Load failed", "NetworkError…") when the network is down: never show that
 *  browser text. App errors carry an HTTP status; our own Error messages (e.g. microphone) are Vietnamese and kept as they are. */
export const isNetworkError = (e: unknown): boolean => e instanceof TypeError && (e as { status?: number }).status === undefined;
export function errorBanner(e: unknown): HTMLElement {
  const err = e as { status?: number; message?: string; code?: string; request_id?: string };
  const msg = isNetworkError(e) ? NETWORK_MESSAGE : err?.message ?? NETWORK_MESSAGE;
  return banner("error", h("p", {}, msg), err?.request_id ? h("p", { class: "small muted" }, `Mã yêu cầu: ${err.request_id}`) : null);
}

export function toast(text: string): void {
  const t = h("div", { class: "toast", role: "status" }, text);
  document.body.append(t);
  setTimeout(() => t.remove(), 3200);
}

export const vnd = (n: number | string | null | undefined): string => n === null || n === undefined ? "—" : `${Number(n).toLocaleString("vi-VN")} VND`;
export const when = (s: string | null | undefined): string => {
  if (!s) return "—";
  const d = new Date(s);
  return `${d.toLocaleTimeString("vi-VN", { hour: "2-digit", minute: "2-digit" })} · ${d.toLocaleDateString("vi-VN")}`;
};
export const initials = (name: string): string => name.split(/\s+/).filter(Boolean).slice(-2).map((w) => w[0]!.toUpperCase()).join("") || "?";

/** Submit helper: disables the button while the request runs, shows the error inline, returns the result or null. */
export async function submit<T = Json>(btn: HTMLButtonElement | null, out: HTMLElement, fn: () => Promise<T>): Promise<T | null> {
  out.replaceChildren();
  if (btn) { btn.disabled = true; btn.setAttribute("aria-busy", "true"); }
  try { return await fn(); }
  catch (e) { out.append(errorBanner(e)); return null; }
  finally { if (btn) { btn.disabled = false; btn.removeAttribute("aria-busy"); } }
}

// UX A–Z RC-02: context kept across navigation and sign-in, in this page's memory only (never storage, never the URL). A full reload or the
// logout (which reloads) drops it; drafts are keyed by the signed-in person, so another person signing in on the same tab sees nothing.
const drafts = new Map<string, Json>();
export const draftGet = (actorId: string, key: string): Json | null => drafts.get(`${actorId}|${key}`) ?? null;
export const draftSet = (actorId: string, key: string, v: Json): void => { drafts.set(`${actorId}|${key}`, v); };
export const draftDrop = (actorId: string, key: string): void => { drafts.delete(`${actorId}|${key}`); };
/** An internal screen path (optionally with a short id-only query); never another origin, "//host", a scheme or a public page. */
const SAFE_RETURN = /^\/(?![/\\])[A-Za-z0-9_\-/]{1,120}(\?[A-Za-z0-9_=&\-]{1,120})?$/;
const NO_RETURN = new Set(["/", "/dang-nhap", "/dang-ky", "/dang-ky/ma", "/dang-ky/tiep-tuc", "/khoi-phuc", "/owner-lan-dau"]);
export const safeReturn = (p: string): string | null => SAFE_RETURN.test(p) && !NO_RETURN.has(p.split("?")[0]!) ? p : null;
let returnTo: { path: string; at: number } | null = null;
/** Remember where a signed-out visit wanted to go (30 minutes); the server re-checks every read when it is opened. */
export function rememberReturn(p: string): void { const s = safeReturn(p); returnTo = s ? { path: s, at: Date.now() } : null; }
export function takeReturn(): string | null {
  const r = returnTo; returnTo = null;
  return r && Date.now() - r.at < 30 * 60_000 ? safeReturn(r.path) : null;
}

export const field = (label: string, input: HTMLElement, hint?: string) => h("label", { class: "field" }, h("span", {}, label), input, hint ? h("small", {}, hint) : null);
export const input = (attrs: Record<string, unknown>) => h("input", { class: "input", ...attrs }) as HTMLInputElement;
export const loading = () => h("div", { class: "stack", "aria-busy": "true" }, h("div", { class: "skeleton" }), h("div", { class: "skeleton" }));

/** Photos are re-encoded to a plain JPEG (≤ 1600 px) in the browser: camera metadata such as GPS never leaves the phone. */
export async function toJpeg(file: File): Promise<{ blob: Blob; dataUrl: string }> {
  // decode without a blob: URL (CSP img-src is 'self' data:): ImageBitmap, else a data: URL
  let source: CanvasImageSource & { width: number; height: number };
  try { source = await createImageBitmap(file); }
  catch {
    const url = await new Promise<string>((res, rej) => { const r = new FileReader(); r.onload = () => res(String(r.result)); r.onerror = () => rej(new Error("Không đọc được ảnh.")); r.readAsDataURL(file); });
    source = await new Promise<HTMLImageElement>((res, rej) => { const i = new Image(); i.onload = () => res(i); i.onerror = () => rej(new Error("Không đọc được ảnh.")); i.src = url; });
  }
  const scale = Math.min(1, 1600 / Math.max(source.width, source.height));
  const c = document.createElement("canvas");
  c.width = Math.max(1, Math.round(source.width * scale)); c.height = Math.max(1, Math.round(source.height * scale));
  c.getContext("2d")!.drawImage(source, 0, 0, c.width, c.height);
  const blob = await new Promise<Blob>((res, rej) => c.toBlob((b) => b ? res(b) : rej(new Error("Không nén được ảnh.")), "image/jpeg", 0.85));
  return { blob, dataUrl: c.toDataURL("image/jpeg", 0.6) };
}

/** Uploads one private bill/evidence file (photo → JPEG, PDF as is) to a raw endpoint; returns the server JSON or throws like api(). */
export async function postFile(path: string, file: File): Promise<Json> {
  const isPdf = file.type === "application/pdf";
  const body = isPdf ? file : (await toJpeg(file)).blob;
  const res = await fetch(path, { method: "POST", credentials: "same-origin", body,
    headers: { "content-type": isPdf ? "application/pdf" : "image/jpeg", "x-b7b-request": "1", "x-b7b-idempotency-key": newKey("file") } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw { status: res.status, ...data };
  return data;
}

/** File picker + upload button for a bill; calls back with the stored object id. */
export function billPicker(label: string, path: () => string, onDone: (objectId: string) => void, doneNote = "Đã tải chứng từ (lưu riêng tư, chỉ anh và người liên quan xem)."): HTMLElement {
  const out = h("div", {});
  const f = h("input", { type: "file", accept: "image/*,application/pdf", class: "input", "aria-label": label }) as HTMLInputElement;
  const b = h("button", { class: "btn btn-secondary btn-sm", type: "button" }, ic("doc", "ic ic-sm"), "Tải chứng từ") as HTMLButtonElement;
  b.addEventListener("click", async () => {
    const file = f.files?.[0];
    if (!file) { out.replaceChildren(banner("warn", h("p", {}, "Chọn ảnh hoặc PDF chứng từ trước."))); return; }
    const r = await submit(b, out, () => postFile(path(), file));
    if (r) { out.replaceChildren(banner("ok", h("p", {}, doneNote))); onDone(r.object_id); }
  });
  return h("div", { class: "stack" }, field(label, f), h("div", { class: "row wrap" }, b), out);
}

export const dateTimeLocal = (iso: string | null | undefined): string => {
  if (!iso) return "";
  const d = new Date(new Date(iso).getTime() + 7 * 3600_000);
  return d.toISOString().slice(0, 16);
};
export const fromLocalVN = (v: string): string => `${v}:00+07:00`;
